<!-- eslint-disable vue/no-mutating-props -->
<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <v-dialog
        class="modal"
        max-width="500"
        v-model="dialog"
        content-class="sc-modal sc-modal--sm"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-tooltip left color="surface_neutral_selected">
        <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
          <div class="card-action-box card-action-box--edit" v-bind="{ ...attrs, ...tooltipAttrs }" v-on="{ ...on, ...tooltipOn }" role="button" aria-label="Editar">
            <v-icon>mdi-pencil</v-icon>
          </div>
        </template>
        <span>Editar</span>
      </v-tooltip>
        </template>

        <v-card v-if="dialog" flat class="sc-modal__card" :key="cronometroData.id">
          <!-- Close button -->
          <v-btn icon class="sc-modal__close" @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <!-- Header -->
          <div class="sc-modal__header">
            <v-icon color="primary" class="mr-3">mdi-timer-outline</v-icon>
            <div>
              <span class="sc-modal__title">Editar cronômetro</span>
              <span class="sc-modal__subtitle">Altere os dados do cronômetro</span>
            </div>
          </div>

          <!-- Body -->
          <div class="sc-modal__body">
            <div class="sc-modal__field">
              <label class="sc-modal__field-label">Título</label>
              <v-text-field
                solo flat dense
                hide-details="auto"
                placeholder="Título do cronômetro..."
                v-model="modalData.dsc_titulo"
                background-color="surface_tertiary"
              />
            </div>

            <div class="sc-modal__field">
              <label class="sc-modal__field-label">Descrição</label>
              <v-textarea
                solo flat dense
                hide-details="auto"
                no-resize
                placeholder="Descrição opcional..."
                rows="3"
                v-model="modalData.dsc_descricao"
                background-color="surface_tertiary"
              />
              <span class="char-counter">{{ (modalData.dsc_descricao || '').trim().length }}</span>
            </div>

            <div class="sc-modal__field">
              <label class="sc-modal__field-label">Tempo</label>
              <div class="time-picker">
                <div class="time-unit">
                  <v-btn icon small class="time-btn" @click="incrementTime('hours')">
                    <v-icon small>mdi-chevron-up</v-icon>
                  </v-btn>
                  <span class="time-value">{{ hours < 10 ? `0${hours}` : `${hours}` }}</span>
                  <v-btn icon small class="time-btn" @click="decrementTime('hours')">
                    <v-icon small>mdi-chevron-down</v-icon>
                  </v-btn>
                  <span class="time-label">h</span>
                </div>
                <span class="time-separator">:</span>
                <div class="time-unit">
                  <v-btn icon small class="time-btn" @click="incrementTime('minutes')">
                    <v-icon small>mdi-chevron-up</v-icon>
                  </v-btn>
                  <span class="time-value">{{ minutes < 10 ? `0${minutes}` : `${minutes}` }}</span>
                  <v-btn icon small class="time-btn" @click="decrementTime('minutes')">
                    <v-icon small>mdi-chevron-down</v-icon>
                  </v-btn>
                  <span class="time-label">m</span>
                </div>
                <span class="time-separator">:</span>
                <div class="time-unit">
                  <v-btn icon small class="time-btn" @click="incrementTime('seconds')">
                    <v-icon small>mdi-chevron-up</v-icon>
                  </v-btn>
                  <span class="time-value">{{ seconds < 10 ? `0${seconds}` : `${seconds}` }}</span>
                  <v-btn icon small class="time-btn" @click="decrementTime('seconds')">
                    <v-icon small>mdi-chevron-down</v-icon>
                  </v-btn>
                  <span class="time-label">s</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="sc-modal__footer">
            <v-btn text class="modal-btn-cancel" @click="close">Cancelar</v-btn>
            <v-btn color="primary" class="modal-btn-confirm" :loading="loading" @click.prevent="alterarCronometro">
              <v-icon small class="mr-1">mdi-check</v-icon>
              Salvar
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </transition>
</template>

<script>
import { apiClient } from "@/services/api";
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    cronometroData: Object,
    isFavoritaTab: Boolean,
    currentPage: Number,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      modalData: {},
      hours: 0,
      minutes: 0,
      seconds: 0,
    };
  },
  computed: {
    ...mapGetters({
      cod_pasta: "pastas/getterCodPasta",
    }),
  },
  watch: {
    dialog(val) {
      if (val) {
        this.populateModalData(this.cronometroData);
      }
    },
  },
  methods: {
    ...mapActions({
      getCronometrosProducao: "cronometros/getCronometrosByProducao",
      getCronometroEmExibicao: "cronometros/getCronometroEmExibicao",
    }),
    populateModalData(data) {
      this.modalData = {
        cod_producao: Number(data.cod_producao),
        id_cronometro: data.id,
        dsc_titulo: data.dsc_titulo || "",
        dsc_descricao: data.dsc_descricao || "",
        tempo: data.tempo,
      };
      const parts = (data.tempo || "00:00:00").split(":");
      this.hours = Number(parts[0]) || 0;
      this.minutes = Number(parts[1]) || 0;
      this.seconds = Number(parts[2]) || 0;
    },
    incrementTime(timeType) {
      if (timeType === "hours") {
        this.hours += 1;
      } else if (timeType === "minutes") {
        this.minutes += 1;
        if (this.minutes === 60) {
          this.hours += 1;
          this.minutes = 0;
        }
      } else {
        this.seconds += 1;
        if (this.seconds === 60) {
          this.minutes += 1;
          this.seconds = 0;
        }
      }
    },
    decrementTime(timeType) {
      if (timeType === "hours") {
        if (this.hours > 0) this.hours -= 1;
      } else if (timeType === "minutes") {
        if (this.minutes > 0) this.minutes -= 1;
      } else {
        if (this.seconds > 0) this.seconds -= 1;
      }
    },
    close() {
      this.dialog = false;
      this.$emit("close");
    },
    async alterarCronometro() {
      if ((this.modalData.dsc_titulo || "").trim() === "") {
        this.$toast.error("Informe o título do cronômetro.");
        return;
      }
      this.loading = true;
      try {
        const hours = this.hours < 10 ? `0${this.hours}` : this.hours;
        const minutes = this.minutes < 10 ? `0${this.minutes}` : this.minutes;
        const seconds = this.seconds < 10 ? `0${this.seconds}` : this.seconds;
        await apiClient.put(
          `cronometro/${this.cronometroData.id}/${this.cronometroData.cod_producao}`,
          {
            dsc_titulo: this.modalData.dsc_titulo,
            dsc_descricao: this.modalData.dsc_descricao,
            tempo: `${hours}:${minutes}:${seconds}`,
          }
        );
        this.$toast.success("Cronômetro atualizado com sucesso.");
        await this.getCronometroEmExibicao({
          cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
        });
        await this.getCronometrosProducao({
          cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
          flg_favorita: this.isFavoritaTab,
          page: this.$store.state.cronometros.cronometrosProducao.currentPage,
          size: 5,
          filtro_texto: this.$store.state.cronometros.filtroCronometros,
          cod_pasta: this.cod_pasta == 0 ? null : this.cod_pasta,
        });
        this.close();
      } catch (err) {
        const msg = err.response?.data?.error || "Erro ao atualizar cronômetro";
        this.$toast.error(msg);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// Modal structure comes from _modal.scss (sc-modal__*).
// Scoped styles below are component-specific: time picker UI + transition.

.char-counter {
  font-size: 0.75rem;
  color: var(--v-text_secondary-base);
  opacity: 0.6;
  text-align: right;
}

/* Time picker */
.time-picker {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px 0;
  background: var(--sc-surface-tint-subtle);
  border: 1px solid var(--sc-border-subtle);
  border-radius: var(--sc-radius-lg);
}

.time-unit {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.time-btn {
  background: var(--sc-surface-tint-hover) !important;
  transition: all var(--sc-duration-fast) var(--sc-easing-standard);

  &:hover {
    background: rgba(var(--sc-color-primary-rgb), 0.15) !important;
    .v-icon { color: var(--v-primary-base) !important; }
  }
}

.time-value {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--v-text_primary-base);
  font-family: monospace;
  line-height: 1;
  min-width: 60px;
  text-align: center;
}

.time-separator {
  font-size: 2rem;
  font-weight: 700;
  color: var(--v-text_secondary-base);
  opacity: 0.4;
  align-self: center;
}

.time-label {
  font-size: 0.7rem;
  color: var(--v-text_secondary-base);
  opacity: 0.5;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* Modal fade */
.modal-fade-enter, .modal-fade-leave-to { opacity: 0; }
.modal-fade-enter-active, .modal-fade-leave-active { transition: opacity var(--sc-duration-slow) var(--sc-easing-standard); }
</style>
